import React, { useState } from 'react';
import { DillButton } from '../../../general/Dill/DillButton';
import { DillModal } from '../../../general/Dill/DillModal';
import { InvitedSignatures } from '@dill/dill-shared';
import { AppInputField } from '../../../general/AppInputField/AppInputField';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { makeCreditAppSignature } from '../../../../redux/services/creditApplicationsService';
import { openDillToast } from '../../../../utils/helpers';

const MakeSignatureRequiredModal = ({
  open,
  handleClose,
  invitedSignature,
  applicationId,
}: {
  open: boolean;
  handleClose: () => void;
  invitedSignature: InvitedSignatures;
  applicationId: string;
}) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState('');
  const [error, setError] = useState('');
  const [notes, setNotes] = useState('');

  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  const handleCloseModal = () => {
    setLoading(false);
    setText('');
    setNotes('');
    handleClose();
  };

  const validate = () => {
    if (text.trim() === '') {
      setError('Email is required');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (text.trim() !== '' && !emailRegex.test(text)) {
      setError('Please enter a valid email');
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);

    const sigDetails = {
      ...invitedSignature,
      email: text,
      minimumNumberOfSignatures: (invitedSignature?.minimumNumberOfSignatures ?? 0) + 1,
      minimumCreditAmount: 0,
    };
    let additionalData = {};
    if (notes.trim()) {
      additionalData = { ...additionalData, notes: notes.trim() };
    }

    const results = await dispatch(
      makeCreditAppSignature({
        creditApplicationId: applicationId,
        invitedSignature: sigDetails,
        supplierId: currentSupplier?.id || '',
        ...additionalData,
      })
    );
    if (results.type.includes('fulfilled')) {
      openDillToast({
        type: 'SUCCESS',
        message: 'Successfully made credit application signature required.',
      });
      setLoading(false);
      handleCloseModal();
    } else {
      openDillToast({
        type: 'ERROR',
        message: 'Failed to make credit application signature required.',
      });
      setLoading(false);
    }
  };

  return (
    <DillModal
      open={open}
      onClose={handleCloseModal}
      title="Add Email For Signature Request"
      footer={
        <>
          <DillButton
            label="Close"
            variant="secondary"
            isDisabled={loading}
            onClick={handleCloseModal}
          />
          <DillButton
            label="Submit"
            onClick={handleSubmit}
            isLoading={loading}
            isDisabled={loading}
          />
        </>
      }>
      <div className="w-full">
        <AppInputField
          isRequired
          label="Email"
          value={text}
          errorText={error}
          placeholder="Enter email address"
          onTextChange={(val) => {
            setText(val);
            setError('');
          }}
        />
      </div>
      <div className="w-full">
        <AppInputField
          label="Notes Message"
          value={notes}
          inputType="textarea"
          onTextChange={(val) => {
            setNotes(val);
          }}
        />
      </div>
    </DillModal>
  );
};

export default MakeSignatureRequiredModal;
